<template>
  <section class="section" ref="section">
    <div class="columns is-centered">
      <div class="column is-one-third">
        <div class="has-text-centered mb-4">
          <span style="font-size: 1.75rem; font-weight: 700; letter-spacing: -0.5px; color: #3273dc;">Fooshi</span>
        </div>
        <div class="has-text-centered" style="margin-bottom: 1.5rem;">
          <LanguageSelector />
        </div>
        <OnboardingProgress :current-step="4" />
        <h3 class="title is-4 is-spaced has-text-centered">
          {{ $t('onboarding.termsAndConditions.title') }}
        </h3>
        <div class="field">
          <div class="box" style="max-height: 40vh; overflow-y: auto; font-size: 0.9rem; line-height: 1.6;">
            <p class="mb-3">{{ $t('onboarding.termsAndConditions.paragraph1') }}</p>

            <p class="has-text-weight-bold mb-2">{{ $t('onboarding.termsAndConditions.vendorObligations') }}</p>
            <ul class="mb-3" style="list-style: disc; padding-left: 1.25rem;">
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation1') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation2') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation3') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation4') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation5') }}</li>
              <li>
                {{ $t('onboarding.termsAndConditions.vendorObligation6') }}
                <ul style="list-style: circle; padding-left: 1.25rem; margin-top: 0.25rem;">
                  <li>{{ $t('onboarding.termsAndConditions.vendorObligation6a') }}</li>
                  <li>{{ $t('onboarding.termsAndConditions.vendorObligation6b') }}</li>
                  <li>{{ $t('onboarding.termsAndConditions.vendorObligation6c') }}</li>
                  <li>{{ $t('onboarding.termsAndConditions.vendorObligation6d') }}</li>
                </ul>
              </li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation7') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation8') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation9') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation10') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation11') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation12') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation13') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation14') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation15') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation16') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation17') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation18') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation19') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation20') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation21') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.vendorObligation22') }}</li>
            </ul>

            <p class="mb-3">{{ $t('onboarding.termsAndConditions.paragraph2') }}</p>

            <p class="has-text-weight-bold mb-2">{{ $t('onboarding.termsAndConditions.fooshiObligations') }}</p>
            <ul class="mb-3" style="list-style: disc; padding-left: 1.25rem;">
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation1') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation2') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation3') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation4') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation5') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation6') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation7') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation8') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation9') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation10') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation11') }}</li>
              <li>{{ $t('onboarding.termsAndConditions.fooshiObligation12') }}</li>
            </ul>

            <p>{{ $t('onboarding.termsAndConditions.paragraph3') }}</p>
          </div>

          <div class="mt-4">
            <label class="checkbox">
              <input type="checkbox" ref="acceptCommision" :true-value="true" :false-value="false"
                v-model="termsAndConditions.acceptCommision" />
              {{ $t('onboarding.termsAndConditions.checkbox1') }}
            </label>
          </div>
        </div>
        <div class="field">
          <label class="checkbox">
            <input type="checkbox" :true-value="true" :false-value="false"
              v-model="termsAndConditions.acceptOrderPolicy" />
            {{ $t('onboarding.termsAndConditions.checkbox2') }}
          </label>
        </div>
        <div class="field">
          <label class="checkbox">
            <input type="checkbox" :true-value="true" :false-value="false" v-model="termsAndConditions.acceptOther" />
            {{ $t('onboarding.termsAndConditions.checkbox3') }}
          </label>
        </div>

        <div class="field" style="position: sticky; bottom: 0; background: #fff; padding: 0.75rem 0; box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.06);">
          <p class="control">
            <primary-button class="is-fullwidth" :label="$t('onboarding.termsAndConditions.accept')" @click="submit()"
              :loading="!ready" :disabled="!allAccepted"></primary-button>

          </p>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { FooshiApi } from '@/services/fooshiApi.service'
import { JwtCookie } from '../../services/jwtCookie.service.js'
import PrimaryButton from '../../components/forms/PrimaryButton.vue'
import LanguageSelector from '../../components/LanguageSelector.vue'
import OnboardingProgress from '@/components/OnboardingProgress.vue'

export default {
  components: {
    PrimaryButton,
    LanguageSelector,
    OnboardingProgress
  },
  methods: {
    async submit () {
      if (
        !this.termsAndConditions.acceptCommision ||
        !this.termsAndConditions.acceptOrderPolicy ||
        !this.termsAndConditions.acceptOther
      ) {
        this.errors = true
      } else {
        this.ready = false
        await this.addTermsAndConditions()
        this.ready = true
      }
    },
    async addTermsAndConditions () {
      try {
        const response = await FooshiApi.addTermsAndConditions(this.termsAndConditions)
        if (response.success) {
          if (window.plausible) window.plausible('Onboarding Step Completed', { props: { stage: 'activation', step: 'terms-accepted' } })
          const onboardingStatus = await FooshiApi.getOnboardingStatus()
          this.step = onboardingStatus.data.step
          JwtCookie.setJwtCookie('fooshistep', this.step, 365)
          this.$router.push('/')
        } else {
          // todo: toast
        }
      } catch (err) { }
    }
  },
  computed: {
    allAccepted () {
      return (
        this.termsAndConditions.acceptCommision &&
        this.termsAndConditions.acceptOrderPolicy &&
        this.termsAndConditions.acceptOther
      )
    }
  },

  mounted () {
    this.ready = true
    this.$nextTick(() => {
      this.$refs.acceptCommision.focus()
    })
  },

  data () {
    return {
      ready: false,
      errors: false,
      step: '',
      termsAndConditions: {
        acceptCommision: false,
        acceptOrderPolicy: false,
        acceptOther: false
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/onBoarding/TermsAndConditions.vue